import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconNotepad = props => (
  <SvgIcon {...props} viewBox="0 0 18 21.793499">
    <path d="m16 1.9813h-4.18c-0.42-1.1492-1.52-1.9813-2.82-1.9813s-2.4 0.83213-2.82 1.9813h-4.18c-1.1 0-2 0.89156-2 1.9812v15.85c0 1.0897 0.9 1.9812 2 1.9812h14c1.1 0 2-0.8915 2-1.9812v-15.85c0-1.0887-0.9-1.9802-2-1.9802zm-7-0.0008c0.55 0 1 0.44578 1 0.99063 0 0.5448-0.45 0.9906-1 0.9906s-1-0.4458-1-0.9906c0-0.5449 0.45-0.9906 1-0.9906zm7 17.832h-14v-15.85h2v2.9719h10v-2.9719h2v15.85z" />
  </SvgIcon>
);

export default IconNotepad;



// WEBPACK FOOTER //
// ./src/components/icons/IconNotepad.js